// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__m88mc","label":"styles_label__I0LX-","description":"styles_description__zS2q3"};